(ns minorodata.logs.api
  (:require [re-posh.core :as re-posh]
            [cljs.spec.alpha :as spec]
            [mold-http.core :refer [reg-event-http]]
            [minorodata.app.utils :as utils]
            [minorodata.logs.model :refer [logs-view log-message ->log-message ->log-pagination]]
            [clojure.string :as cstr]))


(defn get-logs-query-params
  "Helper fn to extract the query params"
  [{:logs-view/keys [type source term page items-per-page sort-by sort-order date-from date-to]
    :or             {sort-order :asc}}]
  (utils/clean-up-query
   (utils/assoc-some
    {:pagination     {:items-per-page (or items-per-page 50)
                      :page           (inc page)}
     :message-type   type
     :message-source source
     :term           term
     :sort           (when (some? sort-by)
                       {:order-by  sort-by
                        :order-dir sort-order})}
    :date-from date-from
    :date-to   date-to)))

(spec/fdef get-logs-query-params
  :args (spec/cat :logs-view logs-view))


(defn response->logs-view [response]
  (let [prev-view @(re-posh/subscribe [:logs-view/pull])
        {:keys [sort]} response
        {:keys [order-by order-dir]} sort]
    (-> prev-view
        (merge {:logs-view/sort-by    (keyword order-by)
                :logs-view/sort-order (cstr/lower-case order-dir)}))))

(defn pagination->logs-view [response]
  (let [prev-view @(re-posh/subscribe [:logs-view/pull])
        {:keys [pagination]} response
        {:keys [page]} pagination]
    (-> prev-view
        (merge {:logs-view/page (dec page)}))))


(spec/fdef response->logs-view
  :args (spec/cat :response map?)
  :ret logs-view)


(defn response->logs [response]
  (->> (:results response)
       (mapv ->log-message)))

(spec/def ::log-messages
  (spec/coll-of log-message))

(spec/fdef response->logs
  :args (spec/cat :response map?)
  :ret ::log-messages)


(defn fetch-logs-request [_ _]
  (let [logs-view  @(re-posh/subscribe [:logs-view/pull])
        logs-query (get-logs-query-params logs-view)]
    {:http-xhrio
     {:id     :fetch-logs
      :url    "/api/log-v2/search"
      :params logs-query}}))

(defn fetch-logs-callback [_ [error response]]
  (if (some? error)
    {:dispatch-n [[:app.events/add-snack :error "Unable to fetch log entries"]
                  [:app.api/log :error (str "Failed to load logs: " error)]]}
    (let [messages (response->logs response)]
      {:dispatch-n [[:log-message/add-many messages]
                    [:logs-pager/add {:logs-pager/messages (map :log-message/id messages)}]
                    [:logs-view/update (response->logs-view response)]]})))

(reg-event-http
 :logs.api/fetch
 fetch-logs-request
 fetch-logs-callback)


(defn fetch-pagination-request [_ _]
  (let [logs-view  @(re-posh/subscribe [:logs-view/pull])
        logs-query (get-logs-query-params logs-view)]
    {:http-xhrio
     {:id     :fetch-logs
      :url    "/api/log-v2/pagination"
      :params logs-query}}))

(defn fetch-pagination-callback [_ [error response]]
  (if (some? error)
    {:dispatch-n [[:app.events/add-snack :error "Unable to fetch pagination information"]
                  [:app.api/log :error (str "Failed to load pagination: " error)]]}
    (let [pagination (:pagination response)]
      {:dispatch-n [[:logs-view/update (pagination->logs-view response)]
                    [:log-pagination/add (->log-pagination pagination)]]})))

(reg-event-http
 :logs.api/fetch-pagination
 fetch-pagination-request
 fetch-pagination-callback)
